import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-posf-fix',
  templateUrl: './posf-fix.component.html',
  styleUrls: ['./posf-fix.component.scss']
})
export class PosfFixComponent implements OnInit {

  data = {
    "info": "AJUNGERE LA TERMEN",
    "type": "ContractCancelledBySupplier",
    "reason": null,
    "authorID": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
    "contract": {
      "id": "12b3b4e9-a763-921c-1556-62c99bf9ab8b",
      "date": "2022-01-01",
      "type": "FURNIZARE",
      "urls": [],
      "place": {
        "code": "594030100003152401",
        "type": "POD",
        "urls": [],
        "address": {
          "cua": null,
          "city": {
            "code": "132084",
            "name": "ARICESTII RAHTIVANI"
          },
          "flat": null,
          "floor": null,
          "stair": null,
          "county": "PH",
          "number": "60A",
          "street": "STADIONULUI",
          "country": "ROMANIA",
          "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
          "building": null,
          "extended": null,
          "position": {
            "geohash": null,
            "latitude": null,
            "longitude": null
          },
          "postcode": "107025",
          "cuaAuthor": null,
          "streetType": "Str."
        },
        "operator": {
          "code": "14476722",
          "name": "DISTRIBUTIE ENERGIE ELECTRICA Romania",
          "extra": null,
          "number": "J12/352/2002 ",
          "address": null,
          "license": "453",
          "operatorId": "92214793-38eb-468b-ad4e-487547dd61b6",
          "incorporation": null,
          "contactAddress": null,
          "legalRepresentative": null,
          "correspondenceAddress": null,
          "legalRepresentativeQuality": null
        },
        "extraData": null,
        "hasProsumer": false,
        "technicalDataGas": null,
        "technicalDataElectricity": {
          "date": null,
          "type": "TechnicalDataElectricity",
          "number": null,
          "status": "CONECTAT",
          "smartMeter": null,
          "consumption": {
            "items": [
              {
                "month": 1,
                "value": "2963"
              },
              {
                "month": 2,
                "value": "2598"
              },
              {
                "month": 3,
                "value": "3106"
              },
              {
                "month": 4,
                "value": "5890"
              },
              {
                "month": 5,
                "value": "2545"
              },
              {
                "month": 6,
                "value": "4436"
              },
              {
                "month": 7,
                "value": "2539"
              },
              {
                "month": 8,
                "value": "2857"
              },
              {
                "month": 9,
                "value": "4920"
              },
              {
                "month": 10,
                "value": "2496"
              },
              {
                "month": 11,
                "value": "2677"
              },
              {
                "month": 12,
                "value": "3102"
              }
            ]
          },
          "counterType": "ACTIVE_REACTIVE",
          "networkType": "D",
          "documentType": null,
          "voltageLevel": 400,
          "counterSeries": "#742173",
          "connectionType": "TRIFAZAT",
          "counterIndexDesc": "1:1046|2:42797|3:212894",
          "counterIndexValue": null,
          "counterIndexInterval": 1,
          "counterIndexReadDate": "2022-08-15",
          "approvedProducedPower": null,
          "approvedConsumptionPower": 2000
        }
      },
      "client": {
        "isPre": null,
        "person": null,
        "company": {
          "code": "28950922",
          "name": "SOLID TERACONSTMM SRL ",
          "extra": null,
          "number": "J29|1207|2011",
          "address": {
            "cua": null,
            "city": {
              "code": "132084",
              "name": "ARICESTII RAHTIVANI"
            },
            "flat": null,
            "floor": null,
            "stair": null,
            "county": "PH",
            "number": "71",
            "street": "PRINCIPALA ARICESTI",
            "country": "ROMANIA",
            "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
            "building": null,
            "extended": null,
            "position": {
              "geohash": null,
              "latitude": null,
              "longitude": null
            },
            "postcode": "107025",
            "cuaAuthor": null,
            "streetType": "Str."
          },
          "incorporation": null,
          "contactAddress": {
            "fax": "0",
            "email": null,
            "phone": "0745034160",
            "mobilePhone": "0745034160"
          },
          "legalRepresentative": {
            "code": "28950922",
            "type": "OTHER",
            "extra": null,
            "number": null,
            "series": null,
            "address": {
              "cua": null,
              "city": {
                "code": "132084",
                "name": "ARICESTII RAHTIVANI"
              },
              "flat": null,
              "floor": null,
              "stair": null,
              "county": "PH",
              "number": "71",
              "street": "PRINCIPALA ARICESTI",
              "country": "ROMANIA",
              "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
              "building": null,
              "extended": null,
              "position": {
                "geohash": null,
                "latitude": null,
                "longitude": null
              },
              "postcode": "107025",
              "cuaAuthor": null,
              "streetType": "Str."
            },
            "lastName": "SOLID TERACONST",
            "firstName": "MM SRL  ",
            "contactAddress": {
              "fax": "0",
              "email": null,
              "phone": "0745034160",
              "mobilePhone": "0745034160"
            },
            "correspondenceAddress": {
              "cua": null,
              "city": {
                "code": "132084",
                "name": "ARICESTII RAHTIVANI"
              },
              "flat": null,
              "floor": null,
              "stair": null,
              "county": "PH",
              "number": "71",
              "street": "PRINCIPALA ARICESTI",
              "country": "ROMANIA",
              "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
              "building": null,
              "extended": null,
              "position": {
                "geohash": null,
                "latitude": null,
                "longitude": null
              },
              "postcode": "107025",
              "cuaAuthor": null,
              "streetType": "Str."
            }
          },
          "correspondenceAddress": {
            "cua": null,
            "city": {
              "code": "132084",
              "name": "ARICESTII RAHTIVANI"
            },
            "flat": null,
            "floor": null,
            "stair": null,
            "county": "PH",
            "number": "71",
            "street": "PRINCIPALA ARICESTI",
            "country": "ROMANIA",
            "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
            "building": null,
            "extended": null,
            "position": {
              "geohash": null,
              "latitude": null,
              "longitude": null
            },
            "postcode": "107025",
            "cuaAuthor": null,
            "streetType": "Str."
          },
          "legalRepresentativeQuality": null
        },
        "prosumer": false,
        "isAgregate": null,
        "preCompany": null,
        "vulnerable": false,
        "aggregatePerson": null,
        "finalClientType": "NON_HOUSEHOLD",
        "uninterruptible": false,
        "aggregateCompany": null
      },
      "number": "2179763-2",
      "operator": {
        "code": "14476722",
        "name": "DISTRIBUTIE ENERGIE ELECTRICA Romania",
        "extra": null,
        "number": "J12/352/2002 ",
        "address": null,
        "license": "453",
        "operatorId": "92214793-38eb-468b-ad4e-487547dd61b6",
        "incorporation": null,
        "contactAddress": null,
        "legalRepresentative": null,
        "correspondenceAddress": null,
        "legalRepresentativeQuality": null
      },
      "supplier": {
        "code": "28909028",
        "name": "ELECTRICA FURNIZARE",
        "extra": null,
        "isFUI": false,
        "number": "J40/8974/2011",
        "address": null,
        "fuiType": "DESEMNAT",
        "license": "2279",
        "supplierId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
        "incorporation": null,
        "contactAddress": null,
        "legalRepresentative": null,
        "correspondenceAddress": null,
        "legalRepresentativeQuality": null
      },
      "marketing": {
        "clientIBAN": null,
        "smsInvoice": null,
        "agreeGDPRTerms": true,
        "agreeContactTerms": true,
        "electronicInvoice": false,
        "agreePlatformTerms": null,
        "communicationChannel": null,
        "electronicMoneyReturn": null
      },
      "offerCode": null,
      "priceType": "NEDIFERENTIAT",
      "consumption": {
        "items": [
          {
            "month": 1,
            "value": "2963"
          },
          {
            "month": 2,
            "value": "2598"
          },
          {
            "month": 3,
            "value": "3106"
          },
          {
            "month": 4,
            "value": "5890"
          },
          {
            "month": 5,
            "value": "2545"
          },
          {
            "month": 6,
            "value": "4436"
          },
          {
            "month": 7,
            "value": "2539"
          },
          {
            "month": 8,
            "value": "2857"
          },
          {
            "month": 9,
            "value": "4920"
          },
          {
            "month": 10,
            "value": "2496"
          },
          {
            "month": 11,
            "value": "2677"
          },
          {
            "month": 12,
            "value": "3102"
          }
        ]
      },
      "serviceType": "CONCURENTIAL",
      "startingDate": "2022-01-01",
      "isFUIContract": null,
      "isNewContract": null,
      "additionalDate": null,
      "contractStatus": "ACTIV",
      "expirationDate": "2022-12-12",
      "additionalNumber": null,
      "clientAmendments": null,
      "conventionNeeded": true,
      "executionAddress": {
        "cua": null,
        "city": {
          "code": "132084",
          "name": "ARICESTII RAHTIVANI"
        },
        "flat": null,
        "floor": null,
        "stair": null,
        "county": "PH",
        "number": "60A",
        "street": "STADIONULUI",
        "country": "ROMANIA",
        "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
        "building": null,
        "extended": null,
        "position": {
          "geohash": null,
          "latitude": null,
          "longitude": null
        },
        "postcode": "107025",
        "cuaAuthor": null,
        "streetType": "Str."
      },
      "previousSupplier": {
        "code": "28909028",
        "name": "ELECTRICA FURNIZARE",
        "extra": null,
        "isFUI": false,
        "number": "J40/8974/2011",
        "address": null,
        "fuiType": "DESEMNAT",
        "license": "2279",
        "supplierId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
        "incorporation": null,
        "contactAddress": null,
        "legalRepresentative": null,
        "correspondenceAddress": null,
        "legalRepresentativeQuality": null
      },
      "previousContractDate": null,
      "previousContractNumber": null,
      "contractWithOperatorNeeded": true,
      "correspondenceClientAddress": {
        "cua": null,
        "city": {
          "code": "132084",
          "name": "ARICESTII RAHTIVANI"
        },
        "flat": null,
        "floor": null,
        "stair": null,
        "county": "PH",
        "number": "71",
        "street": "PRINCIPALA ARICESTI",
        "country": "ROMANIA",
        "authorId": "c4a16c90-f4db-4ffb-8a39-0948761d807c",
        "building": null,
        "extended": null,
        "position": {
          "geohash": null,
          "latitude": null,
          "longitude": null
        },
        "postcode": "107025",
        "cuaAuthor": null,
        "streetType": "Str."
      },
      "correspondenceClientContactAddress": {
        "fax": "0",
        "email": null,
        "phone": "0745034160",
        "mobilePhone": "0745034160"
      }
    },
    "messageID": "e179e8f1-a2a8-4d66-8b56-8a3e56a2d997",
    "timestamp": "2022-12-13T00:00:10.176905Z",
    "authorName": "web posf",
    "reasonDesc": null,
    "description": "<-send from webposf->",
    "correlationID": "e179e8f1-a2a8-4d66-8b56-8a3e56a2d997"
  };

  get code() {
    return JSON.stringify(this.data, null, 2);
  }

  set code(v) {
    try {
      this.data = JSON.parse(v);
    } catch (e) {
      console.log('error occored while you were typing the JSON');
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
